import React, { useEffect, useState, useRef } from 'react';
import { Tooltip, Typography } from '@mui/material';

const isTextOverflowing = (element) => {
    return element.scrollWidth > element.clientWidth;
  };
function OverflowTooltip({ children, fontSize = 'inherit', color = 'inherit', length = 30, maxWidth = '250px' }) {
  const textRef = React.useRef(null);
  const [isOverflowing, setIsOverflowing] = React.useState(false);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(isTextOverflowing(textRef.current) || String(children).length > length);
    }
  }, [children]);

  return (
    <Tooltip title={isOverflowing ? children : ''} arrow>
      <Typography
        ref={textRef}
        noWrap
        style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize, color,maxWidth}}
      >
        {children}
      </Typography>
    </Tooltip>
  );
}

export default OverflowTooltip;
// import React, { useEffect, useState } from 'react';
// import { Tooltip, Typography } from '@mui/material';

// const isTextOverflowing = (element) => {
//   return element.scrollWidth > element.clientWidth;
// };

// function OverflowTooltip({ children, fontSize = '14px', color = 'inherit', length = 30, maxWidth = '250px' }) {
//   const textRef = React.useRef(null);
//   const [isOverflowing, setIsOverflowing] = useState(false);

//   useEffect(() => {
//     if (textRef.current) {
//       setIsOverflowing(isTextOverflowing(textRef.current) || String(children).length > length);
//     }
//   }, [children, length]);

//   return (
//     <Tooltip
//       title={isOverflowing ? children : ''}
//       arrow
//       sx={{
//         fontSize: '2.5rem', // Larger font size for tooltip content
//         padding: '16px 24px', // Match original padding
//         backgroundColor: 'rgba(0, 0, 0, 0.9)', // Match original background
//       }}
//     >
//       <Typography
//         ref={textRef}
//         noWrap
//         style={{
//           overflow: 'hidden',
//           textOverflow: 'ellipsis',
//           whiteSpace: 'nowrap',
//           fontSize, // Use provided fontSize (default 14px to match StyledTableCell)
//           color,
//           maxWidth,
//         }}
//       >
//         {children}
//       </Typography>
//     </Tooltip>
//   );
// }

// export default OverflowTooltip;